import * as Styled from './styled';
import Footer from '~components/dumbs/Footer';
import ButtonWithArrowRight from '~components/dumbs/ButtonWithArrowRight';
import Button from '~components/dumbs/Button';
import { Props } from './types';

function PhotoConfirmation({
  base64Image,
  onClickIsGood,
  onClickTakeAnother,
  rotateImage,
  isLoadingConfirmation,
}: Props) {
  return (
    <Styled.Container>
      <Styled.Image $src={base64Image} $rotate={rotateImage} />
      <Styled.Content>
        <Styled.IsTextPhotoGood>
          A foto ficou com todos os dados legíveis?
        </Styled.IsTextPhotoGood>
      </Styled.Content>
      <Styled.FooterContainer>
        <Footer
          marginTop="auto"
          marginSide="-150px"
          rightButton={
            <ButtonWithArrowRight
              variant="primary"
              width="100%"
              onClick={onClickIsGood}
              disabled={isLoadingConfirmation}
              loading={isLoadingConfirmation}
            >
              Sim
            </ButtonWithArrowRight>
          }
          leftButton={
            <Button
              variant="secondary"
              width="100%"
              onClick={onClickTakeAnother}
              disabled={isLoadingConfirmation}
            >
              Tirar outra
            </Button>
          }
        />
      </Styled.FooterContainer>
    </Styled.Container>
  );
}

PhotoConfirmation.defaultProps = {
  rotateImage: false,
};

export default PhotoConfirmation;
